import { Box, Container, Typography } from "@mui/material";
import { useState } from "react";

import ActionsModal from "../../components/ActionsModal";

import AllArtifactsTable from "./AllArtifacts.table";

const AllArtifacts = () => {
  const [actionNumber, setActionNumber] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleActionClick = (number: number) => {
    setActionNumber(number);
    setShowModal(true);
  };

  return (
    <Container maxWidth="xl">
      <Box mt={3}>
        <Typography variant="h2">Training Center</Typography>
      </Box>
      <Box mt={3}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Artifacts
        </Typography>
        <ActionsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          actionNumber={actionNumber}
        />
        <AllArtifactsTable onActionClick={handleActionClick} />
      </Box>
    </Container>
  );
};

export default AllArtifacts;
